import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-foreground-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-heading text-accent-500 whitespace-nowrap">
                51吃瓜网
              </span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-md">
              51吃瓜网是专注于娱乐热点、明星八卦、社会爆料的综合吃瓜平台。在这里你可以第一时间获取最新吃瓜资讯、热门话题讨论与独家爆料内容，和千万吃瓜群众一起围观热点事件，不错过任何精彩瓜。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-accent-400 mb-4 text-base">
              <a href="/category/entertainment" className="hover:text-accent-300 transition-colors">热门分类</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category/entertainment" className="text-foreground-300 text-sm hover:text-accent-400 transition-colors whitespace-nowrap">
                  娱乐热点
                </Link>
              </li>
              <li>
                <Link to="/category/gossip" className="text-foreground-300 text-sm hover:text-accent-400 transition-colors whitespace-nowrap">
                  明星八卦
                </Link>
              </li>
              <li>
                <Link to="/category/social" className="text-foreground-300 text-sm hover:text-accent-400 transition-colors whitespace-nowrap">
                  社会爆料
                </Link>
              </li>
              <li>
                <Link to="/category/exclusive" className="text-foreground-300 text-sm hover:text-accent-400 transition-colors whitespace-nowrap">
                  独家瓜料
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-accent-400 mb-4 text-base">
              <a href="/about" className="hover:text-accent-300 transition-colors">关于我们</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-foreground-300 text-sm hover:text-accent-400 transition-colors whitespace-nowrap">
                  品牌介绍
                </Link>
              </li>
              <li>
                <a href="/about#reputation" className="text-foreground-300 text-sm hover:text-accent-400 transition-colors whitespace-nowrap">
                  口碑评价
                </a>
              </li>
              <li>
                <a href="/about#contact" className="text-foreground-300 text-sm hover:text-accent-400 transition-colors whitespace-nowrap">
                  联系我们
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-secondary-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-400 text-xs">
            &copy; {currentYear} 51吃瓜网 - 版权所有。本站内容仅供娱乐参考，不构成任何建议。
          </p>
          <div className="flex items-center gap-4 text-foreground-400 text-xs">
            <a href="#" className="hover:text-accent-400 transition-colors whitespace-nowrap" rel="nofollow">用户协议</a>
            <a href="#" className="hover:text-accent-400 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
            <a href="#" className="hover:text-accent-400 transition-colors whitespace-nowrap" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}